import {useContext} from 'react'

import Context from '@s-ui/react-context'

export const useTags = (props = {}) => {
  const {priceRange, bodyTypeIds = [], fuelTypeIds = [], seats, makes} = props
  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {BODY_TYPES, FUEL_TYPES} = config.get('vehicleSpecifications')
  const tags = []
  priceRange && tags.push(priceRange.label)
  bodyTypeIds?.forEach(bodyTypeId => {
    tags.push(i18n.t(BODY_TYPES[bodyTypeId]?.name))
  })
  fuelTypeIds?.forEach(fuelTypeId => {
    tags.push(i18n.t(FUEL_TYPES[fuelTypeId]?.name))
  })
  seats && tags.push(seats.label)
  makes?.forEach(make => tags.push(make))
  return tags
}
